<template>
    <DashboardLayout>
        <Breadcrumb :model="items" />
        <div class="py-4 px-2">
            <div class="text-center mb-8">
                <h2 class="text-900 font-bold mb-2">Available Packages</h2>
            </div>

            <div class="grid justify-content-center gap-4">
                <div class="col-12 md:col-5 lg:col-4 xl:col-3">
                    <PaymentCheckout 
                        packageName="Base Package" 
                        packageCode="00001" 
                        :amount="500.00" 
                        :profile="authStore.user" 
                    />
                </div>
                <div class="col-12 md:col-5 lg:col-4 xl:col-3">
                    <PaymentCheckout 
                        packageName="Standard Package" 
                        packageCode="00002" 
                        :amount="2000.00" 
                        :profile="authStore.user" 
                    />
                </div>
                <div class="col-12 md:col-5 lg:col-4 xl:col-3">
                    <PaymentCheckout 
                        packageName="Premium Package" 
                        packageCode="00003" 
                        :amount="5000.00" 
                        :profile="authStore.user" 
                    />
                </div>
            </div>
        </div>
    </DashboardLayout>
</template>

<script setup>
import DashboardLayout from '@/layout/DashboardLayout.vue';
import Breadcrumb from 'primevue/breadcrumb';
import PaymentCheckout from '@/components/payments/PaymentCheckout.vue';
import { useAuthStore } from '@/stores/authStore';

const items = [{ label: 'Dashboard' }, { label: 'Payments' }];
const authStore = useAuthStore();
</script>